module.exports = __webpack_public_path__ + "static/img/interturis-1.938dc1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/interturis-1.jpg
// module id = JcVe
// module chunks = 1